import { render, staticRenderFns } from "./SipServersList.vue?vue&type=template&id=534c7a50&"
import script from "./SipServersList.vue?vue&type=script&lang=js&"
export * from "./SipServersList.vue?vue&type=script&lang=js&"
import style0 from "./SipServersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports